import { render, staticRenderFns } from "./commDesc.vue?vue&type=template&id=1c47f8dc&scoped=true&"
import script from "./commDesc.vue?vue&type=script&lang=js&"
export * from "./commDesc.vue?vue&type=script&lang=js&"
import style0 from "./commDesc.vue?vue&type=style&index=0&id=1c47f8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47f8dc",
  null
  
)

export default component.exports